module.exports = __webpack_public_path__ + "static/media/dropoutStudy.2a0964dd.pdf";